import {
  type Category,
  type CategoryPagedListQuery,
  type PagedList,
} from 'Types/beFiltersApi'
import { atom } from 'jotai'
import { type CategoryFormState, type ModalDeleteCategoryState } from '../types'

export const defaultEmptyPagedList = {
  Items: [],
  PageCount: 0,
  PageSize: 20,
  PageNumber: 1,
  TotalItems: 0,
}

export const categoriesPagedListAtom = atom<PagedList<Category>>(
  defaultEmptyPagedList,
)

export const defaultPagedQuery: CategoryPagedListQuery = {
  name: '',
  orderBy: 'Id',
  orderDescending: true,
}
export const categoriesQueryAtom =
  atom<CategoryPagedListQuery>(defaultPagedQuery)

export const defaultModalDeleteCategoryState = {
  show: false,
  Id: 0,
}

export const modalDeleteCategoryState = atom<ModalDeleteCategoryState>(
  defaultModalDeleteCategoryState,
)

export const getDefaultCategoryFormState = (): CategoryFormState => {
  return {
    show: false,
    isDirty: false,
    Id: undefined,
    Name: '',
    title: 'Load.FiltersCategories.NewCategory',
  }
}

export const categoryFormState = atom<CategoryFormState>(
  getDefaultCategoryFormState(),
)
